import { render, staticRenderFns } from "./GiftMenuButton.vue?vue&type=template&id=306621e4"
import script from "./GiftMenuButton.vue?vue&type=script&lang=js"
export * from "./GiftMenuButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports